import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import {
  trackConversion,
  TrackConversionRequestDto,
} from '@hc-frontend/services';

import type { ConversionManagerRepository } from '../../domain/repositories/conversion-manager-repository';

type ConversionManagerAdapterFactoryParams = {
  baseUrl: string;
};

export function conversionManagerAdapterFactory(
  options: ConversionManagerAdapterFactoryParams,
): ConversionManagerRepository {
  return {
    async trackConversion({ featureAd, featureAds, placement, sessionId }) {
      const payload: TrackConversionRequestDto = {
        type: 'click',
        value: featureAd.cpc.toString(),
        monetization_platform: 'site',
        transaction_id: `click-site-${featureAds.id}-${featureAd.id}`,
        placement,
        healthcare_session: sessionId,
      };

      try {
        const response = await trackConversion(options.baseUrl, payload);
        if (response.result === 'success') {
          return createSuccessOperationResult(undefined);
        }

        throw new Error(
          `Error tracking conversion of ad with id ${featureAd.id}`,
        );
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            { code: 'failedToTrackConversion', rootCause: error as Error },
          ],
        });
      }
    },
  };
}
